
import HeroImageContent from '~/components/HeroImageContent.vue'

export default {
  components: {
    HeroImageContent,
  },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    alignmentClasses() {
      switch (this.slice.primary.align) {
        case 'left':
          return 'justify-start'
        case 'right':
          return 'justify-end'
        default:
          return 'justify-center'
      }
    },
    widthClasses() {
      switch (this.slice.primary.align) {
        case 'left':
        case 'right':
          return 'w-3/4 xl:w-1/2'
        default:
          return 'w-full max-w-screen-xl'
      }
    },
  },
}
